import React from "react";
import { AlertTriangle, LayoutDashboard, RotateCw } from "lucide-react";

/**
 * Uygulama genelinde kullanılan koyu-temalı hata sınırı.
 * Herhangi bir sayfa render sırasında çökerse simsiyah ekran yerine
 * bu panel çıkar; menü ve üst çubuk çalışmaya devam eder.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Hata konsola düşsün — kullanıcı/geliştirici devtools'tan görebilir.
    // eslint-disable-next-line no-console
    console.error("[YAZTUR ErrorBoundary]", error, info?.componentStack);
  }

  reset = () => {
    this.setState({ error: null });
  };

  goHome = () => {
    this.setState({ error: null });
    window.location.href = "/dashboard";
  };

  render() {
    if (!this.state.error) return this.props.children;
    const msg = String(this.state.error?.message || this.state.error || "Bilinmeyen hata");
    return (
      <div
        data-testid="page-error-boundary"
        className="min-h-[60vh] flex items-center justify-center p-6"
      >
        <div
          className="max-w-xl w-full rounded-xl p-6"
          style={{
            background: "var(--y-surface, #1a1d22)",
            border: "1px solid var(--y-border, #2a2f36)",
            color: "var(--y-text, #e5e7eb)",
          }}
        >
          <div className="flex items-start gap-3">
            <div
              className="w-10 h-10 rounded-md flex items-center justify-center shrink-0"
              style={{ background: "rgba(239,68,68,0.12)", color: "#ef4444" }}
            >
              <AlertTriangle className="w-5 h-5" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[11px] uppercase tracking-widest font-mono" style={{ color: "var(--y-label, #94a3b8)" }}>
                Hata
              </div>
              <h2 className="font-heading font-bold text-lg mt-1">
                Bu sayfa yüklenemedi.
              </h2>
              <p className="mt-2 text-sm" style={{ color: "var(--y-text-2, #cbd5e1)" }}>
                Sayfayı yenileyin veya Kontrol Paneli'ne dönün. Sorun devam ederse yönetici ile iletişime geçin.
              </p>
              <pre
                className="mt-3 text-[11px] font-mono px-3 py-2 rounded max-h-[120px] overflow-auto whitespace-pre-wrap break-words"
                style={{
                  background: "rgba(0,0,0,0.35)",
                  color: "#f87171",
                  border: "1px solid var(--y-border, #2a2f36)",
                }}
                data-testid="page-error-detail"
              >
                {msg}
              </pre>
              <div className="flex flex-wrap gap-2 mt-4">
                <button
                  data-testid="error-go-dashboard"
                  onClick={this.goHome}
                  className="inline-flex items-center gap-2 h-10 px-4 rounded-md text-sm font-semibold"
                  style={{ background: "var(--y-accent, #ff7a1a)", color: "var(--y-accent-fg, #14161a)" }}
                >
                  <LayoutDashboard className="w-4 h-4" />
                  Kontrol Paneli'ne dön
                </button>
                <button
                  data-testid="error-retry"
                  onClick={this.reset}
                  className="inline-flex items-center gap-2 h-10 px-4 rounded-md text-sm"
                  style={{
                    background: "transparent",
                    color: "var(--y-text-2, #cbd5e1)",
                    border: "1px solid var(--y-border, #2a2f36)",
                  }}
                >
                  <RotateCw className="w-4 h-4" />
                  Tekrar dene
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
